import { Observable } from "rxjs";
import NetworkService from "../network/networkService";
import { AgTechQueryParam, OdQueryParam } from "../enums";
import { helperFunctions } from "../helper";
import { IUser, IUserAllResponse } from "../models/IUser.model";
import { URLConfig } from "../network/urlStore";

// JSON Patch operation interface for PATCH requests
interface IPatchOperation {
  op: "replace" | "add" | "remove";
  path: string;
  value?: any;
}

export const getUsers = (
  queryParams?: Array<{
    key: AgTechQueryParam | OdQueryParam;
    value: string[];
  }>
): Observable<IUserAllResponse> => {
  let url = URLConfig.getUsersMasterDataURL();
  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IUserAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching user data", error);
      }
    );
  });
};

export const updateUserPreferredApplication = (
  userId: string | number,
  applicationId: number | null // 1 for APD, 2 for OnFarm, null to clear
): Observable<IUser> => {
  const url = URLConfig.updateUserMasterDataURL(String(userId));
  const patchOperations: IPatchOperation[] = [
    {
      op: "replace",
      path: "/preferredApplicationId",
      value: applicationId
    }
  ];
  
  return new Observable((subscriber) => {
    NetworkService.patch(url, patchOperations).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IUser;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while updating user preferred application", error);
      }
    );
  });
};
export const getUsersNextPage = (
  nextPageURI: string
): Observable<IUserAllResponse> => {
  let url = URLConfig.getUsersNextPageURl(nextPageURI);

  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (locationResponse) => {
        if (locationResponse) {
          const locationsResponse =
            locationResponse as unknown as IUserAllResponse;
          subscriber.next(locationsResponse);
        }

        subscriber.complete();
      },
      (error: any) => {
        subscriber.error(error);
        console.log("Error while fetching Locations master data", error);
      }
    );
  });
};

export const getContentLengthForUser = (
  queryParams?: Array<{
    key: OdQueryParam;
    value: string[];
  }>
): Observable<number> => {
  let url = URLConfig.getUsersMasterDataURL();

  for (let param of queryParams || []) {
    url = helperFunctions.addQueryParam(url, param.key, param.value);
  }

  return new Observable((subscriber) => {
    NetworkService.head(url)
      .then((res: any) => {
        console.log(res);
        subscriber.next(res?.contentLength ?? 0);
        subscriber.complete();
      })
      .catch((error: Error) => {
        subscriber.error(error);
        subscriber.next(0);
        console.log("Error while fetching crops master data:", error);
      });
  });
};

export const createUser = (requestPayload: any): Observable<any> => {
  let url = URLConfig.getUsersMasterDataURL();

  return new Observable((subscriber) => {
    NetworkService.post(url, requestPayload).then(
      (locationResponse) => {
        if (locationResponse) {
          const locationsResponse =
            locationResponse as unknown as IUserAllResponse;
          subscriber.next(locationsResponse);
        }
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while creating a Location", error);
      }
    );
  });
};

export const updateUser = (
  userPayload: any,
  userId: string
): Observable<any> => {
  let url = URLConfig.updateUserMasterDataURL(userId);

  return new Observable((subscriber) => {
    NetworkService.patch(url, userPayload).then(
      (res) => {
        const response = res as unknown as IUser;
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating seasonfield", error);
      }
    );
  });
};
export const deleteUser = (userId: string): Observable<any> => {
  let url = URLConfig.updateUserMasterDataURL(userId);
  return new Observable((subscriber) => {
    NetworkService.delete(url).then(
      (response) => {
        subscriber.next(response);
        subscriber.complete();
      },
      (error) => {
        subscriber.error(error);
        console.log("Error while updating seasonfield", error);
      }
    );
  });
};

export const getUserAccessPermissions = (
  userId: string
): Observable<IUserAllResponse> => {
  let url = URLConfig.getUserAccessPermissionsDataURL(userId);
  return new Observable((subscriber) => {
    NetworkService.get(url).then(
      (res: unknown) => {
        if (res) {
          const response = res as unknown as IUserAllResponse;
          subscriber.next(response);
        }
        subscriber.complete();
      },
      (error: Error) => {
        subscriber.error(error);
        console.log("Error while fetching user data", error);
      }
    );
  });
};